import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import RegistrationModal from "./RegistrationModal";

/**
 * VisitorNav - Navigation component for Visitor Mode (unauthenticated marketing pages)
 * Used on: Landing Page, About, Pricing, FAQ, Contact, Sign In, Sign Up pages
 * 
 * Phase 1 Implementation: Hardcoded for Visitor Mode only
 * Future: Will be enhanced with dynamic mode detection in Phase 2+
 */
const VisitorNav = () => {
  const navigate = useNavigate();
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);

  const handleSignIn = () => {
    navigate('/login');
  };

  const handleGetStarted = () => {
    setShowRegistrationModal(true);
  };

  return (
    <>
      <nav className="sticky top-0 z-40 border-b border-slate-800 bg-slate-950/90 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-3 py-2 sm:px-4 sm:py-3 gap-2">
          {/* Logo Only - Always routes to / - Smaller on mobile */}
          <Link to="/" className="flex items-center group flex-shrink-0">
            <img 
              src="/newaudia-logo.jpg" 
              alt="NewAudia™" 
              className="h-10 sm:h-12 md:h-16 w-auto rounded transition-transform group-hover:scale-105"
            />
          </Link>

          {/* Right Side - Sign In and Get Started Buttons */}
          <div className="flex items-center gap-2 sm:gap-3">
            <button
              onClick={handleSignIn}
              className="rounded-full bg-slate-800 px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm text-slate-100 hover:bg-slate-700 transition-colors whitespace-nowrap flex-shrink-0"
            >
              Sign In
            </button>
            <button
              onClick={handleGetStarted}
              className="rounded-full bg-gradient-to-r from-purple-600 to-indigo-600 px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm text-white font-semibold hover:from-purple-500 hover:to-indigo-500 transition-all whitespace-nowrap flex-shrink-0 shadow-lg shadow-purple-900/30"
              data-testid="get-started-btn"
            >
              <span className="hidden sm:inline">Get Started Free</span>
              <span className="sm:hidden">Join Free</span>
            </button>
          </div>
        </div>
      </nav>

      {/* Registration Modal */}
      <RegistrationModal
        isOpen={showRegistrationModal}
        onClose={() => setShowRegistrationModal(false)}
      />
    </>
  );
};

export default VisitorNav;
